//NOTE(MTH): copied from node server
export enum LC_TABLE_IDS {
	systems = 2,
    tableRegister = 3,
    devicemaps = 5,
    feedplanTimes = 6,
    terminals = 7,
    feedcurves = 11,
    feeddays = 12, 
}